import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import colors from "../config/colors";
import "../styles/simpleExPanel.scss";

import AccordionSummary from "@mui/material/AccordionSummary";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: "100vw",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  panel: {
    borderRadius: 10,
  },
}));

export default function SimpleExpansionPanel({
  title,
  children,
  rightTitle,
  leftTitle,
  opened = false,
  onClick,
  accorditionStyle,
  leftTitleStyle,
  rightTitleStyle,
}) {
  const [expanded, setExpanded] = useState(opened);
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.panel}>
        <Accordion
          onClick={onClick}
          style={{
            // margin: 10,
            borderRadius: 5,
            boxShadow: "0px 0px 10px -2px rgba(0,0,0,.1)",
            maxWidth: "100%",
            width: 900,
            // overflowX: "scroll",
            ...accorditionStyle,
          }}
          className="SimpleExPanel"
          expanded={expanded}
        >
          <AccordionSummary
            expandIcon={children && <ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            style={{
              borderBottom: children && expanded && "1px solid silver",
            }}
            onClick={() => children && setExpanded(!expanded)}
          >
            <div
              style={{
                flexGrow: 1,
                fontWeight: "bold",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                color: colors.primary,
              }}
            >
              <div
                style={{
                  flexGrow: 1,
                  maxWidth: "30%",
                  alignItems: "center",
                  ...leftTitleStyle,
                }}
              >
                {leftTitle}
              </div>
              <div
                className="text-center"
                style={{
                  flexGrow: 1,
                  maxWidth: "30%",
                  alignItems: "center",
                }}
              >
                {title}
              </div>
              <div
                style={{
                  flexGrow: 1,
                  maxWidth: "30%",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  textAlign: "right",
                  ...rightTitleStyle,
                }}
              >
                {rightTitle}
              </div>
            </div>
          </AccordionSummary>
          {children && <AccordionDetails>{children}</AccordionDetails>}
        </Accordion>
      </div>
    </div>
  );
}
